<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col cols="12">
                <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                    <div>
                        <SportipsButton toPage="Home" chevronLeft>Retour à l'accueil</SportipsButton>

                    </div>
                    <div class="text-h5 font-weight-bold text-darkblue">
                        Liste d'attente de {{ mainStore.module.nom }}
                    </div>
                    <v-alert v-if="!has_liste_attente_bourse" border="start" border-color="red" density="compact">Il n'y
                        a pas de liste d'attente pour cet
                        évènement</v-alert>


                    <BourseDossardListListeAttente v-if="bourse_dossard_mode == 'liste_attente'">
                    </BourseDossardListListeAttente>

                </div>

                <!-- Liste des inscriptions -->



            </v-col>
        </v-row>
    </v-container>

</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import BourseDossardListListeAttente from "@/components/BourseDossards/BourseDossardsListListeAttente.vue";

export default {
    name: 'ListeAttenteBourseView',
    components: { BourseDossardListListeAttente },
    computed: {
        ...mapStores(useMainStore),
        has_bourse_dossards() {
            return this.mainStore.module.has_bourse_dossards;
        },
        is_bourse_dossards_active() {
            return this.mainStore.module.bourse_dossards_is_active;
        },
        bourse_dossard_mode() {
            return this.mainStore.module.bourse_dossard_mode;
        },
        has_liste_attente_bourse() {
            return this.mainStore.module.has_liste_attente_bourse;
        },

    },
}
</script>

<style lang="scss" scoped></style>